import MetricBase from "models/metrics/MetricBase";
import i18n from "i18next";
import PercentUnit from "models/metrics/unit/PercentUnit";
import OthersGroup from "../../../../groups/OthersGroup";

class MetricAvgLos extends MetricBase {
    constructor() {
        super({
            field: "metric_avglos",
            defaultVisibility: false,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.tripadvisor.avgLos.chartName"),
            serieLabel: i18n.t("metrics.tripadvisor.avgLos.serieLabel"),
            tooltip: i18n.t("metrics.tripadvisor.avgLos.tooltip"),
            group: new OthersGroup(),
        });
    }
}

export default MetricAvgLos;
